import { AfterViewInit, Component, HostListener, OnInit } from '@angular/core';

import { ApiService } from '@services/api.service';
import { UiHelper } from '@helpers/ui.helper';
import { SignalrServiceLegacy } from '@services/signalr.service.legacy';
import { BehaviorSubject, Observable, of, Subscription } from 'rxjs';
import { DataHelper } from '@helpers/data.helper';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslatePipe } from '@pipes/translate.pipe';
import { LocalizationService } from '@services/localization.service';
import { GroupByTournamentId } from '@pipes/grouplivefixturebytournamentid';
import { FiltersPipe } from '@pipes/filters.pipe';
import { GroupBySportId } from '@pipes/groupbysportid';
import { WebWorkerService } from '../modules/workers/web-worker.service';
import { ChangeDetectorRef } from '@angular/core';
import 'hammerjs';
import { UserHelper } from '@helpers/user.helper';
import { OddComboModel } from './sports.component';
import { environment } from '@environments/environment';

@Component({
  selector: 'live-component',
  templateUrl: '../sharedTemplates/live.component.html',
})
export class LiveComponent implements OnInit, AfterViewInit {
  constructor(
    public _UiHelper: UiHelper,
    private _ApiService: ApiService,
    public _DataHelper: DataHelper,
    public _Router: Router,
    private _ActivatedRoute: ActivatedRoute,
    private _SignalRService: SignalrServiceLegacy,
    private _LocalizationService: LocalizationService,
    private _webWorkerService: WebWorkerService,
    private cdRef: ChangeDetectorRef,
    private _UserHelper: UserHelper
  ) {
    this._DataHelper.getLiveFavoriteTournamentData();

    // Eğer Favori Listesinnde eleman varsa Favori Buttonunun aktifliği kontrol ediliyor
    // Bu Sayede Favori Sayfasındaki Turnuvalar takip edilebilir.
    if (this._DataHelper.liveFavoriteTournamentList.length > 0) {
      this.favoritesIsActive = this._DataHelper.getFavoritesButtonStatus();

      // console.log('--dataRebuild--constructor');
      this.dataRebuild();
    }
  }
  public liveFilterSelectedSportId;

  oddFilterIsActive = false;
  // B3000 için Live Ekranında Single a basınca İlk live datasının EventId si yakalanıyor
  firstLiveEventId = 0;

  favoriteList: Array<any> = [];
  favoritesIsActive = false;

  liveMatchList = [];
  oldLiveMatchList = [];
  cardList = [];
  translator = new TranslatePipe(this._LocalizationService);

  oddLiveMarketingBasketball = [0, 10, 16, 17]; // B3000 Basketball
  oddLiveMarketingTennis = [0, 10, 18, 20]; // B3000 Tennis
  oddLiveMarketingIceHockey = [0, 9, 10, 19]; // B3000 IceHockey
  oddLiveMarketingVolleyball = [0, 10, 18, 21]; // B3000 Volleyball
  oddLiveMarketingBaseball = [0, 10, 16, 17]; // B3000 Baseball
  oddLiveMarketingHandball = [0, 9, 10, 11]; // B3000 Handball
  oddLiveMarketingTableTennis = [0, 9, 10, 18]; // B3000 TableTennis

  oddLiveMarketingB3000Value = [0, 9, 8, 24]; // B3000

  oddLiveMarketingValue = [0, 9, 8];
  isInitialized = false;
  liveMatchobservable = new BehaviorSubject<any>([]);

  storySportsData = this._DataHelper.storySportsData;
  matchFilterBySportKey = '';

  _selectedOdds: OddModel[] = [];
  _FiltersPipe = new FiltersPipe(this._LocalizationService);
  _GroupByTournamentId = new GroupByTournamentId();
  _GroupBySportId = new GroupBySportId();
  _liveFilterItems;

  // Result Live Data
  __ResultLiveData;
  __ResultLiveFavsData;
  contentHeight;
  othersHeight;

  isHeaderShow = true;

  fullmatch: Observable<any[]>;

  oddTypes = this._DataHelper.oddTypes;
  private subscriptionsToStopOnDestroy: Subscription[] = [];
  _fixtureUpcoming = [];
  liveSubscription;
  liveFilterSubscription;
  liveCardSubscription;

  flagSportFilter = false;

  // B3000

  liveFilterSelectedSportIdOld;
  isOpenLeagueMenu = true;
  isOpenSportsMenu = true;

  // [0, 9, 12, 10];
  oddComboList: Array<LiveOddComboModel> = [
    { OddId: 0, OddNameLong: 'tipp_long', OddNameLong2: '', OddName: 'tipp', OddTitles: ['1', 'X', '2'] },
    { OddId: 9, OddNameLong: 'RestofMatch', OddNameLong2: '', OddName: 'RoM', OddTitles: ['1', 'X', '2'] },
    { OddId: 8, OddNameLong: 'NextGoal', OddNameLong2: '', OddName: 'NT', OddTitles: ['1', 'X', '2'] },
    { OddId: 10, OddNameLong: 'O/U_long', OddNameLong2: '', OddName: 'O/U', OddTitles: ['', '+', '-'] },
    { OddId: 11, OddNameLong: 'HTFirstHalf', OddNameLong2: '', OddName: 'HT', OddTitles: ['1', 'X', '2'] },
    { OddId: 11, OddNameLong: 'HTFirstHalf', OddNameLong2: '', OddName: '1x2 HT', OddTitles: ['1', 'X', '2'] },
    { OddId: 12, OddNameLong: 'NextGoal', OddNameLong2: 'OddsFirstHalf', OddName: 'NT', OddTitles: ['1', 'X', '2'] },
    { OddId: 13, OddNameLong: 'RoM HT', OddNameLong2: '', OddName: 'RoM HT', OddTitles: ['1', 'X', '2'] },
    { OddId: 14, OddNameLong: 'Ü/U 1.HZ_long', OddNameLong2: '', OddName: 'Ü/U 1.HZ', OddTitles: ['', '+', '-'] },
    { OddId: 24, OddNameLong: 'Treffenbeide?', OddNameLong2: '', OddName: 'TF?', OddTitles: ['Y', 'N'] },
  ];

  combo1SelectedOdd = this.oddComboList.find(combo => combo.OddId == 0);
  combo2SelectedOdd = this.oddComboList.find(combo => combo.OddId == 9);
  combo3SelectedOdd = this.oddComboList.find(combo => combo.OddId == 8);
  combo4SelectedOdd = this.oddComboList.find(combo => combo.OddId == 24);

  standartSingleId = 1;

  lastRebuildTime = new Date().getTime();

  @HostListener('window:resize', ['$event'])
  onResize() {
    // used windopw-innerWidth   this._UiHelper.setResolution(window.innerWidth,window.innerHeight);
  }

  ngOnInit() {
    if (environment.IsBet3000) {
      this.getUpcomingBet3000();
    } else {
      this.getUpcoming();
    }

    this.clearFavourites();
  }

  ngAfterViewInit() {
    // If connection is not exists
    if (!this._SignalRService.connectionExists) {
      this.subscriptionsToStopOnDestroy.push(
        this._SignalRService.connectionEstablished.subscribe(x => {
          // ////console.log("canlı bağlandı detayda : ", x);
          this.connectHub();
        })
      );
    } else {
      this.connectHub();
    }

    // Daha önce seçilen oddları tekrar seçsin
    this.subscriptionsToStopOnDestroy.push(
      this._ApiService.selectedOddsEvent.subscribe(x => {
        this._selectedOdds = x as OddModel[];
      })
    );
    this._ApiService.getSelectedOdds();
    this._UiHelper.setNavbarTitle('', true, false);

    this.heightsetter(this._UiHelper.windowsHeight);
    this.subscriptionsToStopOnDestroy.push(
      this._UiHelper.windowResized.subscribe(x => {
        this.heightsetter(x.h);
      })
    );

    this.subscriptionsToStopOnDestroy.push(
      this._UiHelper.contentHeightListener.subscribe(x => {
        this.othersHeight = x;
      })
    );

    this.subscriptionsToStopOnDestroy.push(
      this._DataHelper.liveFavouriteStateChanged.subscribe(x => {
        this.dataRebuild();
      })
    );

    setTimeout(() => {
      // this._UiHelper.ScrollToTop();
    }, 100);
  }

  heightsetter(c) {
    this.contentHeight = c - 252;
    this.contentHeight += 'px';
  }
  connectHub() {
    try {
      if (this.liveSubscription != undefined) {
        this.liveSubscription.unsubscribe();
      }
      if (this.liveFilterSubscription != undefined) {
        this.liveFilterSubscription.unsubscribe();
      }
      if (this.liveCardSubscription != undefined) {
        this.liveCardSubscription.unsubscribe();
      }
    } catch (e) {
      console.log(e);
    }
    this.liveSubscription = this._DataHelper.liveDataListener.subscribe(y => {
      this.oldLiveMatchList = this.liveMatchList;
      this.liveMatchList = [...y.map(i => ({ ...i, isLive: true })), ...this._fixtureUpcoming.map(i => ({ ...i, isLive: false }))];

      this.mergeLiveAndUpcoming();

      // //console.log('--dataRebuild--liveDataListener');
      // this.cdRef.detectChanges();
      // this.dataRebuild();
    });

    this.liveMatchobservable.next(this._DataHelper.liveData);
    this.liveMatchList = [...this._DataHelper.liveData.map(i => ({ ...i, isLive: true })), ...this._fixtureUpcoming.map(i => ({ ...i, isLive: false }))];
    this.oldLiveMatchList = this.liveMatchList;

    this.cardList = this._DataHelper.cardData;

    this.liveCardSubscription = this._DataHelper.cardDataListener.subscribe(y => {
      this.cardList = y;
    });

    this._liveFilterItems = this._DataHelper.liveFilterItems;
    //// console.warn("liveFilterSubscription", this._DataHelper.liveFilterItems);
    this.liveFilterSubscription = this._DataHelper.liveFilterItemsListener.subscribe((x: any) => {
      const leagueFilteredData = JSON.parse(localStorage.getItem('league-filter-data'));
      if (x == null || (x.length == 0 && leagueFilteredData != null && leagueFilteredData.length > 0)) {
        this._liveFilterItems = leagueFilteredData;
        this._DataHelper.liveFilterItems = leagueFilteredData;
      } else {
        this._liveFilterItems = x;
        this._DataHelper.liveFilterItems = x;
      }

      this.dataRebuild();

      //// console.log('--dataRebuild--liveFilterSubscription');
    });

    this.dataRebuild();
    // console.log('--dataRebuild--connectHub');

    this.cdRef.detectChanges();

    this._SignalRService.readUpdatedEvents();

    this._UserHelper.favoriedListener.subscribe(x => {
      this.dataRebuild();
    });
  }

  getTeamCard(e, t) {
    if (this.cardList != null) {
      const card = this.cardList.find(s => s.EventId == e);
      if (card != null) {
        if (card.HomeTeamRed != null && t == 'h') {
          return card.HomeTeamRed;
        }
        if (card.AwayTeamRed != null && t == 'a') {
          return card.AwayTeamRed;
        }
      }
    }
  }

  dataRebuild() {
    ////// console.warn(this._liveFilterItems);
    this.lastRebuildTime = new Date().getTime();

    const wwsConfig = {
      langCode: this._LocalizationService.LANGCODE,
      lml: this.liveMatchList,
      old_lml: this.oldLiveMatchList,
      mfbysk: this.matchFilterBySportKey,
      lfi: this._liveFilterItems,
      cardList: this.cardList,
      oddtype: this.oddLiveMarketingValue,
      favorable: this._UserHelper.favoriedMatches,
      isLive: true,
      liveSortbyTime: this._DataHelper.liveSortbyTime,
      liveFavoriteButtonStatus: this._DataHelper.getFavoritesButtonStatus(),
      liveFavoriteData: this._DataHelper.getLiveFavoriteTournamentData(),
      favoriteData: this.checkLiveFavoriMatch(this.liveMatchList),
      time: this.lastRebuildTime,
    };

    if (this.liveMatchList === undefined) {
      return;
    }

    if (this.liveMatchList != undefined && this.liveMatchList.length > 0) {
      this.firstLiveEventId = this.liveMatchList[0].EventId;
    }

    const promise = this._webWorkerService
      .run(this._DataHelper.webWorkerLiveJob, wwsConfig)
      .then(result => {
        if (this.lastRebuildTime > result.time) {
          // console.log('this.lastRebuildTime > result.time', this.lastRebuildTime, result.time);
          return;
        }

        this.__ResultLiveData = result.dt;
        const Obsobj = of(this.__ResultLiveData);

        // console.log('this.fullmatch', result);
        this.fullmatch = Obsobj;

        this._DataHelper.setLiveEventRebuildedUnfiltered(this._GroupByTournamentId.transform(result.dtUn, null));

        this._DataHelper.setLiveGoalListData(result.liveGoalListData);

        // League Filter
        this.isInitialized = true;
        // Fav Data
        this.__ResultLiveFavsData = result.dtFavs;
      })
      .catch(e => {
        // console.error(e)
      });
  }
  getUpcoming() {
    this._ApiService.getUpcomingFixture().then(x => {
      // this.__ResultLiveData.push(...x);
      ////// console.warn("upcoming", x);
      this._fixtureUpcoming = x.map(a => {
        return {
          EventDate: a.MatchDate,
          ...a,
        };
      });
      this.mergeLiveAndUpcoming();
      this.dataRebuild();
      this.cdRef.detectChanges();

      // console.log('--dataRebuild--getUpcoming');

      ////// console.warn("merged",this.__ResultLiveData);
    });
  }

  // upcoming data merged to liveMatchList
  mergeLiveAndUpcoming(): void {
    if (this._fixtureUpcoming && this._fixtureUpcoming.length > 0 && this.liveMatchList && this.liveMatchList.length > 0) {
      this.liveMatchList = [...this._DataHelper.liveData.map(i => ({ ...i, isLive: true })), ...this._fixtureUpcoming.map(i => ({ ...i, isLive: false }))];
    }
    this.liveMatchobservable.next(this.liveMatchList);

    this.dataRebuild();
  }

  // Bet 3000 - Live altındaki Pre ( Upcoming )
  getUpcomingBet3000() {
    this._ApiService
      .getBet3000UpcomingFixture()
      .then(x => {
        this._fixtureUpcoming = x;

        this.mergeLiveAndUpcoming();

        this.cdRef.detectChanges();
        this.dataRebuild();
      })
      .catch(err => console.log('live', err));
  }

  oddLiveMarketingChange(e) {
    if (e) {
      this.oddLiveMarketingValue[0] = e;

      // console.log('--dataRebuild--oddLiveMarketingChange');
      this.dataRebuild();
      //// console.log('E', e);
    }
  }
  checkLiveFavoriMatch(q): number[] {
    const a = localStorage.getItem('_F');
    const favoriedList = a && JSON.parse(a);

    return favoriedList;

    if (favoriedList.length > 0) {
      for (let i = 0; i < q.length; i++) {
        for (let j = 0; j < favoriedList.length; j++) {
          if (q[i].BetradarMatchId === favoriedList[j]) {
            this._UserHelper.reBuildLiveFavoriList(q[i].BetradarMatchId);
          }
        }
      }
    }
  }
  checkOddId(oddId) {
    const index = this._ApiService.slipCurrents.findIndex(v => {
      return v.OddId1 == oddId;
    });
    if (index > -1) {
      return 'active';
    } else {
      return '';
    }
  }

  clickOdd(oddId) {
    this._ApiService.addLiveOdd(oddId);
  }

  goLiveEventDetail(e) {
    // this._Router.navigate(['/eventdetail'], { queryParams: { eventID: e } });
    this._Router.navigate(['/liveeventdetail', e]);
    //// console.log('e', e);
  }
  matchFilterBySport(e) {
    // console.warn('TIKLAMA', e);
    this.liveFilterSelectedSportIdOld = this.liveFilterSelectedSportId;

    if (e) {
      if (e.sportName) {
        this.matchFilterBySportKey = e.sportName;
      }
      if (e.sportId) {
        this.liveFilterSelectedSportId = e.sportId;
      }
    }

    // B3000
    if (e.sportId != this.liveFilterSelectedSportIdOld) {
      this.getOddComboList();
      // console.warn('matchFilterBySport', e);
      if (this.flagSportFilter) {
        this.oddComboChange(this.combo1SelectedOdd, 0);
        this.oddComboChange(this.combo2SelectedOdd, 1);
        this.oddComboChange(this.combo3SelectedOdd, 2);
        this.oddComboChange(this.combo4SelectedOdd, 3);
      }
    }

    this._liveFilterItems = [];
    this._DataHelper.setLiveFilterItems(this._liveFilterItems);

    // //console.log('--dataRebuild--matchFilterBySport');
    //
    this.flagSportFilter = true;
  }

  // Favori Aktif - Pasif
  ToggleFavorites() {
    this.favoritesIsActive = !this.favoritesIsActive;
    this._DataHelper.setFavoritesButtonStatus(this.favoritesIsActive);

    // console.log('--dataRebuild--ToggleFavorites');
    this.dataRebuild();
  }

  favorableStateChanged(e, _id) {
    this._UserHelper.toogleFavoried(_id);
  }

  favsChanged() {
    // Rebind Favs

    // console.log('--dataRebuild--favsChanged');
    this.dataRebuild();
  }

  onlyMatches() {
    // this.isHeaderShow ? this.isHeaderShow = false : this.isHeaderShow = true;

    this._DataHelper.liveSortbyTime = false;
    this.isHeaderShow = true;

    // console.log('--dataRebuild--onlyMatches');

    this.dataRebuild();
  }

  sortByTime() {
    // this._DataHelper.liveSortbyTime = !this._DataHelper.liveSortbyTime;

    this.isHeaderShow = false;
    this._DataHelper.liveSortbyTime = true;

    // console.log('--dataRebuild--sortByTime');

    this.dataRebuild();
  }

  sportName(e) {
    if (typeof this.oddLiveMarketingValue === 'object') {
      const _a = [];
      if (this.oddLiveMarketingValue != undefined) {
        this.oddLiveMarketingValue.forEach(_y => {
          Object.prototype.hasOwnProperty.call(this.oddTypes[_y], e) ? _a.push(e) : _a.push('all');
        });
      }
      return _a;
    } else if (typeof this.oddLiveMarketingValue === 'string' || typeof this.oddLiveMarketingValue === 'number') {
      return Object.prototype.hasOwnProperty.call(this.oddTypes[this.oddLiveMarketingValue], e) ? [e] : ['all'];
    }
  }

  // Live da biten maçları Favoriden Temizleme
  clearFavourites() {
    this._DataHelper.liveFavoriteTournamentList.forEach(f => {
      const filter = this.liveMatchList.filter(x => x.TournamentId == f);
      if (filter.length == 0) {
        const index = this._DataHelper.liveFavoriteTournamentList.indexOf(f);
        this._DataHelper.liveFavoriteTournamentList.splice(index, 1);
        this._DataHelper.setFavoritesButtonStatus(false);
      }
    });
  }

  ngOnDestroy() {
    this._DataHelper.setLiveGoalListData([]);

    this.clearFavourites();

    // Favourites Button Status Clean
    this._DataHelper.setFavoritesButtonStatus(false);

    // League Filter Clean ( Local Storage )
    localStorage.setItem('league-filter-data', JSON.stringify([]));

    try {
      if (this.liveSubscription != undefined) {
        this.liveSubscription.unsubscribe();
      }
      if (this.liveFilterSubscription != undefined) {
        this.liveFilterSubscription.unsubscribe();
      }
      if (this.liveCardSubscription != undefined) {
        this.liveCardSubscription.unsubscribe();
      }
    } catch (e) {
      console.log(e);
    }

    for (const subscription of this.subscriptionsToStopOnDestroy) {
      if (subscription) {
        subscription.unsubscribe();
      }
    }
  }

  toggleLeagueMenu() {
    this.isOpenLeagueMenu = !this.isOpenLeagueMenu;
  }

  toggleSportsMenu() {
    this.isOpenSportsMenu = !this.isOpenSportsMenu;
  }
  oddComboChange(oddMarket, index) {
    const newOddMarket: number[] = Array.from(this.oddLiveMarketingB3000Value);
    newOddMarket[index] = oddMarket.OddId;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    this.oddLiveMarketingB3000Value = newOddMarket;
    this.dataRebuild();
  }

  getOddComboList() {
    // if (this.liveFilterSelectedSportId == 1){
    //   this.getSoccerComboList();
    //   this.oddLiveMarketingB3000Value = [0, 9, 8, 10];
    //   this.dataRebuild();
    //   return;
    // }
    if (this.liveFilterSelectedSportId == 2) {
      this.getBasketballComboList();
      this.oddLiveMarketingB3000Value = this.oddLiveMarketingBasketball;
      this.dataRebuild();
      return;
    } else if (this.liveFilterSelectedSportId == 3) {
      this.getBaseballComboList();
      this.oddLiveMarketingB3000Value = this.oddLiveMarketingBaseball;
      this.dataRebuild();
      return;
    } else if (this.liveFilterSelectedSportId == 4) {
      this.getIceHockeyComboList();
      this.oddLiveMarketingB3000Value = this.oddLiveMarketingIceHockey;
      this.dataRebuild();
      return;
    } else if (this.liveFilterSelectedSportId == 5) {
      this.getTennisComboList();
      this.oddLiveMarketingB3000Value = this.oddLiveMarketingTennis;
      this.dataRebuild();
      return;
    } else if (this.liveFilterSelectedSportId == 6) {
      this.getHandballballComboList();
      this.oddLiveMarketingB3000Value = this.oddLiveMarketingHandball;
      this.dataRebuild();
      return;
    } else if (this.liveFilterSelectedSportId == 17) {
      this.getTableTennisComboList();
      this.oddLiveMarketingB3000Value = this.oddLiveMarketingTableTennis;
      this.dataRebuild();
      return;
    } else if (this.liveFilterSelectedSportId == 20) {
      this.getVolleyballComboList();
      this.oddLiveMarketingB3000Value = this.oddLiveMarketingVolleyball;
      this.dataRebuild();
      return;
    }

    this.oddComboList = [
      { OddId: 0, OddNameLong: 'tipp_long', OddNameLong2: '', OddName: 'tipp', OddTitles: this.getOddTitles(this.liveFilterSelectedSportId) },
      { OddId: 9, OddNameLong: 'RestofMatch', OddNameLong2: '', OddName: 'RoM', OddTitles: this.getOddTitles(this.liveFilterSelectedSportId) },
      { OddId: 8, OddNameLong: 'NextGoal', OddNameLong2: '', OddName: 'NT', OddTitles: ['1', 'X', '2'] },
      { OddId: 10, OddNameLong: 'O/U_long', OddNameLong2: '', OddName: 'O/U', OddTitles: ['', '+', '-'] },

      { OddId: 22, OddNameLong: 'handicap', OddNameLong2: '', OddName: 'hc', OddTitles: ['', '1', 'X', '2'] },
      { OddId: 23, OddNameLong: 'DoppelteChance', OddNameLong2: '', OddName: 'DC', OddTitles: ['1X', '12', 'X2'] },
      { OddId: 24, OddNameLong: 'Treffenbeide?', OddNameLong2: '', OddName: 'TF?', OddTitles: ['Y', 'N'] },

      { OddId: 11, OddNameLong: 'HTFirstHalf', OddNameLong2: '', OddName: '1x2 HT', OddTitles: this.getOddTitles(this.liveFilterSelectedSportId) },
      { OddId: 12, OddNameLong: 'NT_HZ_long', OddNameLong2: '', OddName: 'NT_HZ', OddTitles: this.getOddTitles(this.liveFilterSelectedSportId) },

      { OddId: 13, OddNameLong: 'RoM HT', OddNameLong2: '', OddName: 'RoM HT', OddTitles: this.getOddTitles(this.liveFilterSelectedSportId) },
      { OddId: 14, OddNameLong: 'Ü/U 1.HZ_long', OddNameLong2: '', OddName: 'Ü/U 1.HZ', OddTitles: ['', '+', '-'] },
    ];
    this.getComboSelected();

    // NOTES
    // Tennis ten Soccer a geçtiğinde ; 2.Combodaki Uber/Unter Olan Combo İsmi Soccer da değişiyor.(Restzeitwette oluyor). Fakat data değişmiyor. Uber/Unter dataları geliyor.
  }

  getBasketballComboList() {
    this.oddComboList = [
      { OddId: 0, OddNameLong: '2way_long', OddNameLong2: '', OddName: '2way_short', OddTitles: ['1', '2'] },
      { OddId: 10, OddNameLong: 'O/U_basketball_long', OddNameLong2: '', OddName: 'O/U_basketball_short', OddTitles: ['', '+', '-'] },
      { OddId: 16, OddNameLong: 'HomeTotal_Long', OddNameLong2: '', OddName: 'HomeTotal_Short', OddTitles: ['', '+', '-'] },
      { OddId: 17, OddNameLong: 'AwayTotal_Long', OddNameLong2: '', OddName: 'AwayTotal_Short', OddTitles: ['', '+', '-'] },
    ];
    this.getComboSelectedBasketball();
  }

  getTennisComboList() {
    this.oddComboList = [
      { OddId: 0, OddNameLong: '2way_long', OddNameLong2: '', OddName: '2way_short', OddTitles: ['1', '2'] },
      { OddId: 10, OddNameLong: 'O/U_long', OddNameLong2: '', OddName: 'O/U', OddTitles: ['', '+', '-'] },
      { OddId: 18, OddNameLong: 'TennisSet_Long', OddNameLong2: '', OddName: 'TennisSet_Short', OddTitles: ['1', '2'] },
      { OddId: 20, OddNameLong: 'TennisTotalSet_Long', OddNameLong2: '', OddName: 'TennisTotalSet_Short', OddTitles: ['1', '2'] },
    ];
    this.getComboSelectedTennis();
  }

  getIceHockeyComboList() {
    this.oddComboList = [
      { OddId: 0, OddNameLong: 'tipp_long', OddNameLong2: '', OddName: 'tipp', OddTitles: ['1', '2'] },
      { OddId: 9, OddNameLong: 'RestofMatch', OddNameLong2: '', OddName: 'RoM', OddTitles: this.getOddTitles(this.liveFilterSelectedSportId) },
      { OddId: 10, OddNameLong: 'O/U_long', OddNameLong2: '', OddName: 'O/U', OddTitles: ['', '+', '-'] },
      { OddId: 19, OddNameLong: 'IceHockeyPeriod_Long', OddNameLong2: '', OddName: 'IceHockeyPeriod_Short', OddTitles: ['', '+', '-'] },
    ];
    this.getComboSelectedIceHockey();
  }

  getVolleyballComboList() {
    this.oddComboList = [
      { OddId: 0, OddNameLong: '2way_long', OddNameLong2: '', OddName: '2way_short', OddTitles: this.getOddTitles(this.liveFilterSelectedSportId) },
      { OddId: 10, OddNameLong: 'O/U_long', OddNameLong2: '', OddName: 'O/U', OddTitles: ['', '+', '-'] },
      { OddId: 18, OddNameLong: 'TennisSet_Long', OddNameLong2: '', OddName: 'TennisSet_Short', OddTitles: ['1', '2'] },
      { OddId: 21, OddNameLong: 'TennisTotalSet_Long', OddNameLong2: '', OddName: 'TennisTotalSet_Short', OddTitles: ['1', 'X', '2'] },
    ];
    this.getComboSelectedVolleyball();
  }

  getHandballballComboList() {
    this.oddComboList = [
      { OddId: 0, OddNameLong: 'tipp_long', OddNameLong2: '', OddName: 'tipp', OddTitles: this.getOddTitles(this.liveFilterSelectedSportId) },
      { OddId: 9, OddNameLong: 'RestofMatch', OddNameLong2: '', OddName: 'RoM', OddTitles: this.getOddTitles(this.liveFilterSelectedSportId) },
      { OddId: 10, OddNameLong: 'O/U_long', OddNameLong2: '', OddName: 'O/U', OddTitles: ['', '+', '-'] },
      { OddId: 11, OddNameLong: 'HTFirstHalf', OddNameLong2: '', OddName: '1x2 HT', OddTitles: this.getOddTitles(this.liveFilterSelectedSportId) },
    ];
    this.getComboSelectedHandball();
  }

  getTableTennisComboList() {
    this.oddComboList = [
      { OddId: 0, OddNameLong: '2way_long', OddNameLong2: '', OddName: '2way_short', OddTitles: ['1', '2'] },
      { OddId: 9, OddNameLong: 'RestofMatch', OddNameLong2: '', OddName: 'RoM', OddTitles: this.getOddTitles(this.liveFilterSelectedSportId) },
      { OddId: 10, OddNameLong: 'O/U_long', OddNameLong2: '', OddName: 'O/U', OddTitles: ['', '+', '-'] },
      { OddId: 18, OddNameLong: 'TennisSet_Long', OddNameLong2: '', OddName: 'TennisSet_Short', OddTitles: ['1', '2'] },
    ];
    this.getComboSelectedTableTennis();
  }

  getBaseballComboList() {
    this.oddComboList = [
      { OddId: 0, OddNameLong: 'tipp_long', OddNameLong2: '', OddName: 'tipp', OddTitles: ['1', '2'] },
      { OddId: 10, OddNameLong: 'O/U_basketball_long', OddNameLong2: '', OddName: 'O/U_basketball_short', OddTitles: ['', '+', '-'] },
      { OddId: 16, OddNameLong: 'HomeTotal_Long', OddNameLong2: '', OddName: 'HomeTotal_Short', OddTitles: ['', '+', '-'] },
      { OddId: 17, OddNameLong: 'AwayTotal_Long', OddNameLong2: '', OddName: 'AwayTotal_Short', OddTitles: ['', '+', '-'] },
    ];
    this.getComboSelectedBaseball();
  }

  getComboSelected() {
    this.combo1SelectedOdd = this.oddComboList.find(combo => combo.OddId == 0);
    this.combo2SelectedOdd = this.oddComboList.find(combo => combo.OddId == 9);
    this.combo3SelectedOdd = this.oddComboList.find(combo => combo.OddId == 8);
    this.combo4SelectedOdd = this.oddComboList.find(combo => combo.OddId == 24);

    this._DataHelper.comboSelectedOdd = this.combo1SelectedOdd;
  }

  getComboSelectedBasketball() {
    this.combo1SelectedOdd = this.oddComboList.find(combo => combo.OddId == 0);
    this.combo2SelectedOdd = this.oddComboList.find(combo => combo.OddId == 10);
    this.combo3SelectedOdd = this.oddComboList.find(combo => combo.OddId == 16);
    this.combo4SelectedOdd = this.oddComboList.find(combo => combo.OddId == 17);

    this._DataHelper.comboSelectedOdd = this.combo1SelectedOdd;
  }

  getComboSelectedBaseball() {
    this.combo1SelectedOdd = this.oddComboList.find(combo => combo.OddId == 0);
    this.combo2SelectedOdd = this.oddComboList.find(combo => combo.OddId == 10);
    this.combo3SelectedOdd = this.oddComboList.find(combo => combo.OddId == 16);
    this.combo4SelectedOdd = this.oddComboList.find(combo => combo.OddId == 17);

    this._DataHelper.comboSelectedOdd = this.combo1SelectedOdd;
  }

  getComboSelectedTennis() {
    this.combo1SelectedOdd = this.oddComboList.find(combo => combo.OddId == 0);
    this.combo2SelectedOdd = this.oddComboList.find(combo => combo.OddId == 10);
    this.combo3SelectedOdd = this.oddComboList.find(combo => combo.OddId == 18);
    this.combo4SelectedOdd = this.oddComboList.find(combo => combo.OddId == 20);

    this._DataHelper.comboSelectedOdd = this.combo1SelectedOdd;
  }

  getComboSelectedIceHockey() {
    this.combo1SelectedOdd = this.oddComboList.find(combo => combo.OddId == 0);
    this.combo2SelectedOdd = this.oddComboList.find(combo => combo.OddId == 9);
    this.combo3SelectedOdd = this.oddComboList.find(combo => combo.OddId == 10);
    this.combo4SelectedOdd = this.oddComboList.find(combo => combo.OddId == 19);

    this._DataHelper.comboSelectedOdd = this.combo1SelectedOdd;
  }

  getComboSelectedVolleyball() {
    this.combo1SelectedOdd = this.oddComboList.find(combo => combo.OddId == 0);
    this.combo2SelectedOdd = this.oddComboList.find(combo => combo.OddId == 10);
    this.combo3SelectedOdd = this.oddComboList.find(combo => combo.OddId == 18);
    this.combo4SelectedOdd = this.oddComboList.find(combo => combo.OddId == 21);

    this._DataHelper.comboSelectedOdd = this.combo1SelectedOdd;
  }

  getComboSelectedHandball() {
    this.combo1SelectedOdd = this.oddComboList.find(combo => combo.OddId == 0);
    this.combo2SelectedOdd = this.oddComboList.find(combo => combo.OddId == 9);
    this.combo3SelectedOdd = this.oddComboList.find(combo => combo.OddId == 10);
    this.combo4SelectedOdd = this.oddComboList.find(combo => combo.OddId == 11);

    this._DataHelper.comboSelectedOdd = this.combo1SelectedOdd;
  }

  getComboSelectedTableTennis() {
    this.combo1SelectedOdd = this.oddComboList.find(combo => combo.OddId == 0);
    this.combo2SelectedOdd = this.oddComboList.find(combo => combo.OddId == 9);
    this.combo3SelectedOdd = this.oddComboList.find(combo => combo.OddId == 10);
    this.combo4SelectedOdd = this.oddComboList.find(combo => combo.OddId == 18);

    this._DataHelper.comboSelectedOdd = this.combo1SelectedOdd;
  }

  getOddTitles(id: number) {
    if (id == 2 || id == 5 || id == 20) {
      return ['1', '2'];
    } else {
      return ['1', 'X', '2'];
    }
  }

  oddBoxClick(oddMarket, index) {
    this.combo1SelectedOdd = oddMarket;
    this._DataHelper.comboSelectedOdd = oddMarket;

    const newOddMarket: number[] = Array.from(this.oddLiveMarketingB3000Value);
    newOddMarket[index] = oddMarket.OddId;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    this.oddLiveMarketingB3000Value = newOddMarket;
  }
  StandartSingleChange(id) {
    this.standartSingleId = id;

    if (id === 2) {
      this._Router.navigate(['/liveeventdetail', this.firstLiveEventId]);
      // this._DataHelper.liveDataListener.subscribe((y) => {
      //   this.liveMatchList = y;
      // });

      // this.liveDataList.forEach(x => {
      //   if (x.type === 'Match') {
      //     // console.warn('EventId',x.EventId);
      //     this._Router.navigate(['/liveeventdetail', x.EventId]);
      //     return;
      //   }
      // });
    }
  }

  oddFilterToggle() {
    this.oddFilterIsActive = !this.oddFilterIsActive;
  }

  getResponsiveOddShow(indexOddOrder) {
    switch (indexOddOrder) {
      case 1:
        return this._UiHelper.isResponsiveRules(['s']);
      case 2:
        return this._UiHelper.isResponsiveRules(['xl']);
      case 3:
        return this._UiHelper.isResponsiveRules(['xxl']);
      default:
        return true;
    }
  }
}

export class OddModel {
  constructor(OddId: number, OddName: string, OddTitles: []) {
    this.OddId = OddId;
    this.OddName = OddName;
    this.OddTitles = OddTitles;
  }

  OddId: number;
  OddName: string;
  OddTitles: string[];
}

export class LiveOddComboModel {
  constructor(OddId: number, OddName: string, OddNameLong: string, OddNameLong2: string, OddTitles: []) {
    this.OddId = OddId;
    this.OddName = OddName;
    this.OddTitles = OddTitles;
    this.OddNameLong = OddNameLong;
    this.OddNameLong2 = OddNameLong2;
  }

  OddId: number;
  OddName: string;
  OddTitles: string[];
  OddNameLong: string;
  OddNameLong2: string;
}
